import { renderTableClientModuleTemplate } from '@next-adapter/templates/renderers/generators/form-admin/admin-table.js'
export function generateTable(
  pascal: string,
  kebab: string,
  label: string,
  actionImportPath: string
): string {
  return renderTableClientModuleTemplate({
    pascal: pascal,
    actionImportPath: actionImportPath,
    kebab: kebab,
    label: label
  })
}
